import { Link } from 'react-router-dom';
import logo from '../sabith logo.png';

export default function Footer() {
  return (
    <footer className="bg-charcoal border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Sabitha Studio" className="h-10 w-auto" />
              <div>
                <h3 className="font-playfair text-lg gold-text">Sabitha Studio</h3>
                <p className="text-[10px] text-warm-gray tracking-[0.2em] uppercase">Since 1989</p>
              </div>
            </Link>
            <p className="text-cream/50 text-xs leading-relaxed">
              A complete photography & videography service provider, trusted by generations of families.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-montserrat text-xs tracking-[0.2em] uppercase text-gold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/wedding', label: 'Wedding' },
                { to: '/baby-shoot', label: 'Baby Shoot' },
                { to: '/stills', label: 'Stills' },
                { to: '/anniversary', label: '25th Anniversary' },
                { to: '/about', label: 'About Us' },
                { to: '/contact', label: 'Contact Us' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-cream/50 text-sm hover:text-gold transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-montserrat text-xs tracking-[0.2em] uppercase text-gold mb-4">Services</h4>
            <ul className="space-y-2">
              {[
                'Wedding Photography',
                'Cinematic Videography',
                'Pre-Wedding Shoots',
                'Baby & Family',
                'Portraits & Passport',
              ].map((s) => (
                <li key={s} className="text-cream/50 text-sm">{s}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-montserrat text-xs tracking-[0.2em] uppercase text-gold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+919703377033" className="text-cream/50 text-sm hover:text-gold transition-colors flex items-start gap-2">
                  <svg className="w-4 h-4 text-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                    <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                  </svg>
                  +91-9703377033
                </a>
              </li>
              <li className="text-cream/50 text-xs leading-relaxed flex items-start gap-2">
                <svg className="w-4 h-4 text-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
                  <path d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                </svg>
                <span>
                  C-18, First Floor, Green Square Plaza, Opp. Public Gardens, Hanamkonda - 506001
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gold/5 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-cream/30 text-xs">
            &copy; {new Date().getFullYear()} Sabitha Studio. All rights reserved.
          </p>
          <p className="text-cream/30 text-xs">
            Capturing memories since 1989
          </p>
        </div>
      </div>
    </footer>
  );
}
